import React from "react";


function ComingSoon() {
  return (
    <>
   
      <div className="container">
        <div className="coming-soon">
          <div className="Page-wrapper">
            <div className="row flex-wrap justify-content-center align-items-center">
              <div className="col-md-6 d-flex justify-content-end align-items-center mx-auto mb-auto">
                <div className="comming-soon-pg d-flex flex-column align-items-center justify-content-center">
                  <div>
                    <img src="assets/img/bg/coming-soon.svg" className="img-fluid" />
                  </div>
                  {/* <ul className="d-inline-flex align-items-center justify-content-center mb-3">
                    <li className="me-sm-3 me-2">
                      <div className="d-flex flex-column align-items-center">
                        <div className="d-flex counts-card align-items-center mb-2 justify-content-center flex-column border rounded bg-primary px-sm-4 py-sm-3 p-2">
                          <h3 className="days fs-sm-30 text-white fs-24">54</h3>
                        </div>
                        <p className="text-gray-9 fw-medium fs-16">Days</p>
                      </div>
                    </li>
                    <li className="text-gray fw-bold fs-30 me-sm-3 mb-4 me-2">
                      :
                    </li>
                    <li className="me-sm-3 me-2">
                      <div className="d-flex flex-column align-items-center">
                        <div className="d-flex align-items-center  counts-card mb-2 justify-content-center flex-column border rounded bg-primary px-sm-4 py-sm-3 p-2">
                          <h3 className="hours fs-sm-30 text-white fs-24">2</h3>
                        </div>
                        <p className="text-gray-9 fw-medium fs-16">Hours</p>
                      </div>
                    </li>
                    <li className="text-gray fw-bold fs-30 me-sm-3 mb-4 me-2">
                      :
                    </li>
                    <li className="me-sm-3 me-2">
                      <div className="d-flex flex-column align-items-center">
                        <div className="d-flex align-items-center  counts-card mb-2 justify-content-center flex-column border rounded bg-primary px-sm-4 py-sm-3 p-2">
                          <h3 className="minutes fs-sm-30 text-white fs-24">
                            54
                          </h3>
                        </div>
                        <p className="text-gray-9 fw-medium fs-16">Minutes</p>
                      </div>
                    </li>
                    <li className="text-gray fw-bold fs-30 me-sm-3 mb-4 me-2">
                      :
                    </li>
                    <li>
                      <div className="d-flex flex-column align-items-center">
                        <div className="d-flex align-items-center  counts-card mb-2 justify-content-center flex-column border rounded bg-primary px-sm-4 py-sm-3 p-2">
                          <h3 className="seconds fs-sm-30 text-white fs-24">
                            10
                          </h3>
                        </div>
                        <p className="text-gray-9 fw-medium fs-16">Seconds</p>
                      </div>
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ComingSoon;
